<template>
  <div class="head-menu">
    <div class="container">
      <!-- 头部左边 -->
      <div class="leftMenu">
        <ul>
          <li><a href="http://oa.univ-bio.com/Home/index">OA首页</a></li>
          <li>
            <a href="JavaScript:void(0);" @click="setHome(this, 'http://oa.univ-bio.com')" >设为首页</a>
          </li>
          <li>
            <a href="javascript:void(0);" @click="addFavorite('我的网站', 'http://oa.univ-bio.com')">加入收藏</a>
          </li>
          <li v-if="getNavLint && getNavLint.length > 0">
            常用功能：<el-link
              v-for="(item, index) in getNavLint.length > 5 ? getNavLint.slice(0, 5) : getNavLint"
              :key="index" :href="item.url" >
                {{ item.nav_name }}
              </el-link>
          </li>
        </ul>
      </div>
      <!-- 头部右边 -->
      <div class="rightMenu">
        <ul>
          <li>{{ userName }}</li>
          <li><a href="javascript:;" @click="loginout">安全退出</a></li>
          <el-popover
            placement="top-end"
            width="700"
            :offset="0"
            @show="showPopver"
            trigger="hover">
            <div class="site-map-list">
              <div>
                <p
                  style="
                    color: #e60012;
                    font-size: 14px;
                    margin-bottom: 5px;
                    margin-top: 7px;
                  "
                >
                  常用功能
                </p>
                <div class="link-list">
                  <el-link
                    style="margin: 2px 10px 5px 0"
                    v-for="i in getNavLint"
                    :key="i.index"
                    :href="i.url"
                    >{{ i.nav_name }}
                  </el-link>
                </div>
              </div>
              <div v-for="(item, index) in navList" :key="index">
                <p
                  style="font-size: 14px; margin-bottom: 5px; margin-top: 7px"
                  :style="{ color: navColor[index] }"
                >
                  {{ item.name }}
                </p>
                <div class="link-list">
                  <el-link
                    style="margin: 2px 10px 5px 0"
                    v-for="i in item"
                    :key="i.index"
                    :href="i.url" >
                    {{ i.nav_name }}
                  </el-link>
                </div>
              </div>
            </div>
            <span style="height: 30px; line-height: 30px" slot="reference" >网站导航&nbsp;<i class="el-icon-arrow-down"></i></span>
          </el-popover>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "Header",
  props:['navListAll'],
  computed: {
    ...mapGetters([
      'userName'
    ]),
    getNavLint(){
        return this.$store.state.user.menus
    }
  },
  data() {
    return {
      navList: [],
      navColor: [
        "#13B5B1",
        "#009944",
        "#8FC31F",
        "#F39800",
        "#008DF6",
        "#009944",
        "#00479D",
      ],
    };
  },
  mounted() {
  },
  methods: {
    //设为首页
    setHome(obj, url) {
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage(url);
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "抱歉，此操作被浏览器拒绝！\n\n请在浏览器地址栏输入“about:config”并回车然后将[signed.applets.codebase_principal_support]设置为'true'"
            );
          }
        } else {
          alert(
            "抱歉，您所使用的浏览器无法完成此操作。\n\n您需要手动将【" + url +"】设置为首页。"
          );
        }
      }
    },
    //收藏本站
    addFavorite(title, url) {
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        try {
          window.sidebar.addPanel(title, url, "");
        } catch (e) {
          alert(
            "抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加"
          );
        }
      }
    },
    showPopver(){
        this.getNavlist();
    },
    getNavlist() {
      //导航
      let arr = [];
      for (var i in this.navListAll) {
        this.navListAll[i]["name"] = i;
        arr.push(this.navListAll[i]);
      }
      this.navList = arr;
    },
    async loginout() {
      await this.$store.dispatch('user/logout')
    },
  }
};
</script>
<style lang='scss' scoped>
.head-menu {
  width: 100%;
  background: #e5e5e5;
  font-size: 13px;
  position: absolute;
  left: 0;
  top: 0;
  .container {
    width: 80%;
    min-width: 1200px;
    margin: 0 auto;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ul {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    li {
      padding: 0 14px;
      height: 12px;
      line-height: 12px;
      margin: 9px 0;
      & + li {
        border-left: 1px solid #555555;
      }
      &:last-child {
        display: inline-flex;
        align-items: center;
      }
      & >>> .el-link.el-link--default {
        font-size: 13px;
        margin-right: 10px;
      }
    }
    .leftMenu li:first-child {
      padding-left: 0;
      a {
        margin-right: 4px;
      }
    }
  }
  .site-map-list {
    background: #ffffff;
    padding: 12px 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    .link-list {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue